"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _stepDetails = _interopRequireDefault(require("../step-details/step-details"));

var _makeVideoButton = _interopRequireDefault(require("./make-video-button/make-video-button"));

const WelcomeScreen = props => {
  const {
    title,
    description,
    buttonText,
    onSelect,
    logoUrl,
    link,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('welcome-screen', className)
  }, /*#__PURE__*/_react.default.createElement(_stepDetails.default, {
    title: title,
    description: description,
    href: logoUrl,
    link: link
  }, /*#__PURE__*/_react.default.createElement(_makeVideoButton.default, {
    className: "welcome-screen__make-video-button",
    onClick: onSelect
  }, buttonText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-screen__image-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "welcome-screen__image"
  })));
};

WelcomeScreen.propTypes = {
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  buttonText: _propTypes.default.string.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  logoUrl: _propTypes.default.string,
  link: _propTypes.default.func,
  className: _propTypes.default.string
};
WelcomeScreen.defaultProps = {
  logoUrl: null,
  link: null,
  className: ''
};
var _default = WelcomeScreen;
exports.default = _default;